import React from "react";

export default function DashboardSummaryCard({
  label,
  value,
  accent,
  subLabel,
  danger = false,
  clickable = false,
  onClick,
  actionHint = "클릭하여 위험 해제",
}) {
  return (
    <div
      onClick={clickable ? onClick : undefined}
      role={clickable ? "button" : undefined}
      className={`group relative w-full rounded-[26px] border p-5 text-left sm:p-6 xl:p-5 ${
        danger
          ? "border-red-400 bg-red-50 shadow-[0_0_0_2px_rgba(248,113,113,0.16),0_20px_44px_rgba(239,68,68,0.20)] dark:border-red-700 dark:bg-red-950/35"
          : "border-white/70 bg-white/92 shadow-[0_16px_40px_rgba(15,23,42,0.06)] dark:border-white/10 dark:bg-[#111827]/82"
      } ${clickable ? "cursor-pointer" : "cursor-default"}`}
    >
      {danger && (
        <>
          <span className="pointer-events-none absolute inset-0 rounded-[26px] border-2 border-red-400/80 animate-pulse" />
          <span className="pointer-events-none absolute -inset-1 rounded-[30px] bg-red-400/10 animate-ping" />
        </>
      )}

      <div className="relative">
        <div className={`text-[13px] font-semibold ${accent}`}>{label}</div>

        <div className="mt-4 text-[38px] font-bold leading-none tracking-tight sm:text-[44px]">
          {value}
        </div>

        {/* 설명은 평소 숨김, 카드에 커서 올리면 스르륵 나타남 (아이콘 없이 깔끔) */}
        {subLabel ? (
          <div className="mt-3 translate-y-1 text-[13px] text-gray-500 opacity-0 transition-all duration-200 group-hover:translate-y-0 group-hover:opacity-100 dark:text-gray-400">
            {subLabel}
          </div>
        ) : null}

        {danger && clickable && (
          <div className="mt-3 text-xs font-semibold text-red-600 dark:text-red-300">
            {actionHint}
          </div>
        )}
      </div>
    </div>
  );
}
